import React, { PureComponent } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { DRNButton } from '@traveloka/district-ui';

import {
  pageState,
  withPageStateProvider,
} from 'common/libs/PageState/pageState';
import R from 'common/res/R';
import Modal from 'common/components/Modal/Modal';
import BusAutoCompleteStationContainer from '../../containers/BusAutoCompleteStationContainer';
import BusBookingStationField from '../../containers/BusBookingStationFieldContainer';
import BusBookingDateField from '../../containers/BusBookingDateFieldContainer';
import BusBookOnBehalfField from '../../containers/BusBookOnBehalfFieldContainer';

export const BUS_STATION_SELECTION_TYPE_ORIGIN = 'origin';
export const BUS_STATION_SELECTION_TYPE_DESTINATION = 'destination';

const styles = StyleSheet.create({
  container: {
    backgroundColor: R.color.uiLightPrimary,
  },
  contentContainer: {
    padding: R.spacing.m,
  },
  buttonSearch: {
    marginTop: R.spacing.m,
  },
});

@withPageStateProvider()
@pageState()
class BusBookingSearchForm extends PureComponent {
  state = {
    showPointAutocomplete: false,
    pointAutocompleteType: BUS_STATION_SELECTION_TYPE_ORIGIN,
  };

  constructor(props) {
    super(props);

    this.handleShowStationSearch = this.handleShowStationSearch.bind(this);
    this.handleCloseStationSearch = this.handleCloseStationSearch.bind(this);
    this.handleChangeStation = this.handleChangeStation.bind(this);
    this.handleSubmitSearchForm = this.handleSubmitSearchForm.bind(this);
    this.handleShowOriginStationSearch = this.handleShowOriginStationSearch.bind(
      this
    );
    this.handleShowDestinationStationSearch = this.handleShowDestinationStationSearch.bind(
      this
    );
    this.handleOnSelectAgent = this.handleOnSelectAgent.bind(this);
  }

  componentDidMount() {
    this.props.prefillSearchForm(true);
  }

  handleShowStationSearch(pointAutocompleteType) {
    const { isInputDisabled } = this.props;
    if (isInputDisabled) return;

    this.props.fetchAutoCompleteStation('', pointAutocompleteType);

    this.setState({ showPointAutocomplete: true, pointAutocompleteType });
  }

  handleCloseStationSearch = () => {
    this.setState({ showPointAutocomplete: false });
  };

  async handleChangeStation(item) {
    const { pointAutocompleteType: type } = this.state;

    if (type === BUS_STATION_SELECTION_TYPE_ORIGIN) {
      await this.props.setOrigin(item);
    } else if (type === BUS_STATION_SELECTION_TYPE_DESTINATION) {
      await this.props.setDestination(item);
    }

    this.handleCloseStationSearch();
  }

  @pageState({ error: 'snackbar.error' })
  handleSubmitSearchForm() {
    const {
      navigation,
      rescheduleTransactionId,
      isRescheduleFlow,
    } = this.props;

    const errorMessage = this.props.validateSearchForm();

    if (errorMessage) {
      throw new Error(errorMessage);
    } else {
      navigation.push('BusBookingSearchResult', {
        isRescheduleFlow,
        rescheduleTransactionId,
      });
    }
  }

  handleShowOriginStationSearch() {
    const { isInputDisabled } = this.props;
    if (isInputDisabled) return;
    this.handleShowStationSearch(BUS_STATION_SELECTION_TYPE_ORIGIN);
  }

  handleShowDestinationStationSearch() {
    const { isInputDisabled } = this.props;
    if (isInputDisabled) return;
    this.handleShowStationSearch(BUS_STATION_SELECTION_TYPE_DESTINATION);
  }

  handleOnSelectAgent() {
    this.props.prefillSearchForm();
  }

  render() {
    const { isRescheduleFlow, isInputDisabled } = this.props;
    const { showPointAutocomplete, pointAutocompleteType } = this.state;

    return (
      <ScrollView
        style={styles.container}
        contentContainerStyle={styles.contentContainer}
      >
        <BusBookingStationField
          type={BUS_STATION_SELECTION_TYPE_ORIGIN}
          onPress={this.handleShowOriginStationSearch}
        />
        <BusBookingStationField
          type={BUS_STATION_SELECTION_TYPE_DESTINATION}
          onPress={this.handleShowDestinationStationSearch}
        />
        <BusBookingDateField onDateChange={this.handleDateChange} />

        {!isRescheduleFlow && (
          <BusBookOnBehalfField onSelectAgent={this.handleOnSelectAgent} />
        )}

        <Modal isVisible={showPointAutocomplete} style={{ margin: 0 }}>
          <BusAutoCompleteStationContainer
            key={String(showPointAutocomplete)}
            onSelectStation={this.handleChangeStation}
            onClose={this.handleCloseStationSearch}
            pointAutocompleteType={pointAutocompleteType}
          />
        </Modal>

        <DRNButton
          text="Cari"
          style={styles.buttonSearch}
          buttonStyle={R.style.buttonBrandPrimary}
          onPress={this.handleSubmitSearchForm}
          disabled={isInputDisabled}
        />
      </ScrollView>
    );
  }
}
export default BusBookingSearchForm;
